// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QWc2xCOMIcKRaWPKq3lQ {
  display: flex;
  align-items: center;
  gap: 0;
  margin: 24px 0;
}

.wmL4Srpu_80X0naR2t2M {
  width: 302px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
}

.CK2FjoLLw81DRXZrJP5C {
  font-family: var(--font-stack-full-regular);
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 500;
  color: var(--grey-color-90);
}

.pPLZJr2jqhLUiBB35TeF {
  font-family: var(--font-stack-full-heavy);
  line-height: 24px;
  font-size: 1rem;
  font-weight: 800;
  color: var(--grey-color-90);
}

._TDk2pFLRxNn2rYDyb1E {
  width: 100%;
  background-color: var(--grey-color-200);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.NArpAeusVMKFTWfu2sN3 {
  width: 302px;
  align-items: center;
}

.F1PuX2ICgtpbeP9fiEo0 {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.Io8HnJeox3j6rcjJiPNA {
  flex: 1 1 48%;
  margin-right: 32px;
}

.EUExuiE790mMJx6hrZNs {
  display: flex;
  align-items: center;
  flex: 1 1 48%;
}

.XWh02evrl1dxepalFcv9 {
  display: flex;
}

.xMpTi_gitnnzIZgTYX1w {
  writing-mode: vertical-rl;
  padding: 6px 12px;
  text-align: center;
  margin-right: 16px;
  background-color: var(--grey-color-10);
  border-radius: 12px;
}

.uaF4e4fqwcDY1_yUf3hx {
  transform: rotate(180deg);
}

.e_qvSg90remgtfr5Aen9 {
  width: 100%;
  margin-top: 6px;
}

.Qrr3HENdbqit0udvXmtb {
  flex: 1 1 48%;
}

.dr1gDPfmH67UagqKg7XE {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.Fcq36HYoCi3B0tJbv5y5 {
  width: 100%;
  margin: 24px 0 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.ZmYZoSO0H2COD4YXeBBm {
  width: 238px;
}

.A_M2s9ltWRI_UuOVYTTh {
  flex: 1 1 auto;
  display: flex;
}

.Zp6JaSDlQhHeKgrdBPaT {
  flex: 1 1 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 32px;
}

.BPUMopES7DIp7fmktlvx {
  display: flex;
  gap: 2px;
}

.B5_yQ6o0jcxYJ0067mow {
  margin: 24px 0;
}

.dfYXUcG3cGEb6lDErucD {
  margin: 12px 0;
}

.FxG6oR0UDwa4j3X871Wu {
  height: 1px;
  margin: 18px 0 24px;
  background-color: var(--grey-color-200);
}`, "",{"version":3,"sources":["webpack://./src/components/HoganFactorChart/HoganFactorChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AACA;EACE,yCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,QAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,uCAAA;AAEF","sourcesContent":[".skillsTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin: 24px 0;\n}\n\n.scoreLabelContainer {\n  width: 302px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  cursor: pointer;\n}\n\n.scoringLabel {\n  font-family: var(--font-stack-full-regular);\n  line-height: 1.5;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--grey-color-90);\n}\n.boxlabelTitle {\n  font-family: var(--font-stack-full-heavy);\n  line-height: 24px;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--grey-color-90);\n}\n\n.factorChartHeaderComponentBox {\n  width: 100%;\n  background-color: var(--grey-color-200);\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.titleAverageDistributionBox {\n  width: 302px;\n  align-items: center;\n}\n\n.averageAndDistributionBox {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.averageScoreBox {\n  flex: 1 1 48%;\n  margin-right: 32px;\n}\n\n.distributionLevelBox {\n  display: flex;\n  align-items: center;\n  flex: 1 1 48%;\n}\n\n.mainTitleContainer {\n  display: flex;\n}\n\n.verticalTitleBox {\n  writing-mode: vertical-rl;\n  padding: 6px 12px;\n  text-align: center;\n  margin-right: 16px;\n  background-color: var(--grey-color-10);\n  border-radius: 12px;\n}\n\n.verticalTitle {\n  transform: rotate(180deg);\n}\n\n.titleAverageDistributionContainer {\n  width: 100%;\n  margin-top: 6px;\n}\n\n.distributionLevelMainBoxesContainer {\n  flex: 1 1 48%;\n}\n\n.boxMainTitle {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.secondTitleMainBox {\n  width: 100%;\n  margin: 24px 0 12px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.emptyFirstBox {\n  width: 238px;\n}\n\n.averageAndDistributionTitleContainer {\n  flex: 1 1 auto;\n  display: flex;\n}\n\n.averageScoreAndTargetContainer {\n  flex: 1 1 48%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 32px;\n}\n\n.targetLabelAndIcon {\n  display: flex;\n  gap: 2px;\n}\n\n.boxesSpacing {\n  margin: 24px 0;\n}\n\n.spacingForMiddleBoxes {\n  margin: 12px 0;\n}\n\n.dividerLine {\n  height: 1px;\n  margin: 18px 0 24px;\n  background-color: var(--grey-color-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skillsTitleContainer": `QWc2xCOMIcKRaWPKq3lQ`,
	"scoreLabelContainer": `wmL4Srpu_80X0naR2t2M`,
	"scoringLabel": `CK2FjoLLw81DRXZrJP5C`,
	"boxlabelTitle": `pPLZJr2jqhLUiBB35TeF`,
	"factorChartHeaderComponentBox": `_TDk2pFLRxNn2rYDyb1E`,
	"titleAverageDistributionBox": `NArpAeusVMKFTWfu2sN3`,
	"averageAndDistributionBox": `F1PuX2ICgtpbeP9fiEo0`,
	"averageScoreBox": `Io8HnJeox3j6rcjJiPNA`,
	"distributionLevelBox": `EUExuiE790mMJx6hrZNs`,
	"mainTitleContainer": `XWh02evrl1dxepalFcv9`,
	"verticalTitleBox": `xMpTi_gitnnzIZgTYX1w`,
	"verticalTitle": `uaF4e4fqwcDY1_yUf3hx`,
	"titleAverageDistributionContainer": `e_qvSg90remgtfr5Aen9`,
	"distributionLevelMainBoxesContainer": `Qrr3HENdbqit0udvXmtb`,
	"boxMainTitle": `dr1gDPfmH67UagqKg7XE`,
	"secondTitleMainBox": `Fcq36HYoCi3B0tJbv5y5`,
	"emptyFirstBox": `ZmYZoSO0H2COD4YXeBBm`,
	"averageAndDistributionTitleContainer": `A_M2s9ltWRI_UuOVYTTh`,
	"averageScoreAndTargetContainer": `Zp6JaSDlQhHeKgrdBPaT`,
	"targetLabelAndIcon": `BPUMopES7DIp7fmktlvx`,
	"boxesSpacing": `B5_yQ6o0jcxYJ0067mow`,
	"spacingForMiddleBoxes": `dfYXUcG3cGEb6lDErucD`,
	"dividerLine": `FxG6oR0UDwa4j3X871Wu`
};
export default ___CSS_LOADER_EXPORT___;
